import React from 'react';
import { TOCToolboxTypes } from './types';

import { ReactNode } from 'react';
import { Typography } from '@material-ui/core';

export const chartTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Volg je leerlingen op
    </Typography>
    <Typography variant="subtitle2">
      Onze dashboards tonen exact hoe je leerlingen vorderen zodat jij de juiste leerlingen kan
      helpen.
    </Typography>
  </>
);

const searchTooltipContent = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Vind de les die je zoekt
    </Typography>
    <Typography variant="subtitle2">
      Zoek op lesonderwerp en vind onmiddellijk het traject dat erbij past.
    </Typography>
  </>
);

const lockTooltipContent = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Toon wat de leerlingen al mogen zien
    </Typography>
    <Typography variant="subtitle2">
      Vergrendel trajecten waar leerlingen nog niet in mogen kijken.
    </Typography>
  </>
);

const donwloadTooltipContent = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Toetsen, teksten en nog veel meer
    </Typography>
    <Typography variant="subtitle2">
      Download extra materiaal bij de methode. Jaarplannen, toetsen, kaarten, teksten... ze staan
      voor je klaar.
    </Typography>
  </>
);

const printTooltipContent = (
  <div>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Download (en print) de theorie
    </Typography>
    <Typography variant="subtitle2">
      Alle theorie van de methode in één overzichtelijke pdf.
    </Typography>
  </div>
);

export const getContent = (type: TOCToolboxTypes): NonNullable<ReactNode> => {
  let content: NonNullable<ReactNode> = <></>;
  switch (type) {
    case 'chart':
      content = chartTooltipContent;
      break;

    case 'search':
      content = searchTooltipContent;
      break;

    case 'lock':
      content = lockTooltipContent;
      break;

    case 'donwload':
      content = donwloadTooltipContent;
      break;

    case 'print':
      content = printTooltipContent;
      break;

    default:
      break;
  }
  return content;
};
